import { ClassImporterExporter, ImportMap } from "../resources/class-importer-exporter.service";

export class DbObject {
    id?: string | number;
    static dbEndpoint: string;
    static dbTypeName: string;
    static importMap: ImportMap<any, any>;
    static fromDbObject: (data: any) => any;
}

export class CHDbObject {
    id?: string;
    static dbTypeName: string;
}
export interface IDbHelper<T, D> {
    dbTypeName: string;
    dbTypeNamePlural: string;
    importMap: ImportMap<T, D>;
    fromDbObject: (dbObject: D) => T;
    toDbObject: (obj: T) => D;
}
export abstract class DbHelper<T, D> implements IDbHelper<T, D> {
    /** Noun to use in dialogs / messages (singular) */
    dbTypeName: string;
    /** Noun to use in dialogs / messages (plural) */
    dbTypeNamePlural: string;
    importMap: ImportMap<T, D> = [];

    /**
     * convert object from db syntax to app syntax
     *
     * @param dbObject db object
     * @returns app object
     */
    fromDbObject(dbObject: D): T {
        return ClassImporterExporter.importObject(dbObject, this.importMap);
    }

    /**
     * convert object from app syntax to db syntax
     *
     * @param obj app object
     * @returns db object
     */
    toDbObject(obj: T): D {
        return ClassImporterExporter.exportObject(obj, this.importMap);
    }
}
